export const DEFAULT_LIMIT_PER_DAY = 10000;
export const DEFAULT_PAGE_SIZE = 30;
export const DISPLAY_DATE_FORMAT = 'DD.MM.YYYY';
export const PAGE_SIZE_OPTIONS = [30, 50, 100];